













import blockMixin from './../BlockMixin.vue'

export default {
  name: 'tweet'

  mixins: [blockMixin]

  data: -> {
    fields: {
      id: ''
    }
  }

  mounted: ->
    this.$el.querySelector('.bb8-block-tweet-id').focus() if this.block.fields.id.length <= 0

  methods: {
    loadTweet: (event) ->
      vm = this
      id = event.target.value
      return if id == ''
      this.block.fields.id = id

      window.twttr = this.loadTwitterWidgetJS(->
        window.twttr.widgets.createTweet(
          id,
          vm.$el.querySelector('.bb8-block-tweet'),
          {}
        )
      )

    loadTwitterWidgetJS: (callback) ->
      js = fjs = document.getElementsByTagName('script')[0]
      t = window.twttr || {}

      if document.getElementById('twitter-wjs')
        callback()
        return t

      js = document.createElement('script')
      js.onreadystatechange = ->
        if js.readyState == 'loaded' || js.readyState == 'complete'
          js.onreadystatechange = null
          callback()
      js.onload = -> callback()
      js.id = 'twitter-wjs'
      js.src = '//platform.twitter.com/widgets.js'
      fjs.parentNode.insertBefore(js, fjs)

      t._e = []
      t.ready = (f) -> t._e.push(f)

      return t

    removeBlock: (event, checkId = false) ->
      return if checkId && event.target.value.length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/TweetBlock.vue